function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.833 2.5a7.5 7.5 0 00-7.5 7.5h-2.5l3.242 3.242.058.116L7.5 10H5a5.83 5.83 0 015.833-5.833A5.829 5.829 0 0116.667 10a5.829 5.829 0 01-5.834 5.833 5.786 5.786 0 01-4.116-1.716L5.533 15.3a7.463 7.463 0 005.3 2.2 7.5 7.5 0 000-15zM10 6.667v4.166l3.567 2.117.6-1.008-2.917-1.734V6.667H10z",
    fill: props.fill
  }));
}
export default SvgHistory;